<template>
  <div>
    <img
      v-if="productType === 'io'"
      src="@assets/images/OKKI.io.svg"
      class="Logo"
    >
    <img
      v-else-if="productType === 'leads_personal'"
      src="@assets/images/LeadsAI.svg"
      alt="Logo 2"
      class="Logo"
    >
    <img
      v-else
      src="@assets/images/OKKI.svg"
      alt="Logo 2"
      class="Logo"
    >
  </div>
</template>

<script>
export default {
  props: {
    productType: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>
/* Add any necessary styles for the logos here */
</style>
